import { httpCreate } from './http';

const http = httpCreate('/srv/activity-interact-cards');

export const activityInteract = {
	// 兑奖码查询
	interactCards(activityId, winNo) {
		return http.get(`/${activityId}/${winNo}`);
	},
};
